import React, { useRef, useEffect, useState } from "react";
import { Card, CardActionArea } from "@material-ui/core";
import Webcam from "react-webcam";
import { runBlazeFace, stopBlazeFace, drawRef, clearRef, loadBlazeFaceModel } from "../../api/BlazeFace";
import { useVideo } from "../../api/VideoProvider";
import { pRecordVideo, pWebcam, pVideoConstraints, pVideoConstraintsPortrait, pRecordVideoPortrait, pVideoConstraintsSquare, pRecordVideoSquare, pStatus } from "../../utils/parameters";
import { useReactMediaRecorder } from "react-media-recorder";
import { CountdownTimer } from "../../components/home/CountdownTimer";
import { RecordingChip } from "./RecordingChip";
import Tooltip from '@mui/material/Tooltip';
import imgIdeal_0 from "../../assets/icons/sig_IdealFrame_0b.png";
import imgIdeal_1 from "../../assets/icons/sig_IdealFrame_1b.png";
import { useTranslation } from "react-i18next";

export function WebcamCard(props) {
  const { children, devicePortrait, setVideo, permissions, deviceId,  switchGalibo, handleSendButton } = props;
  const { t } = useTranslation("global")
  
  /* Video */
  const { startRecording, stopRecording, status, mediaBlobUrl } = useReactMediaRecorder(devicePortrait ? { ...pRecordVideoPortrait, video:{ ...pRecordVideoPortrait.video, deviceId: {exact: deviceId} } } : { ...pRecordVideo, video:{ ...pRecordVideo.video, deviceId: {exact: deviceId} } });
  const { setFaceStatus, faceStatus } = useVideo();
  const [ videoFeedAspectRatio, setVideoFeedAspectRatio ] = useState();
  const [ forceAspect, setForceAspect ] = useState(false);
  /* Refs */
  const canvasRef = useRef(null);
  const auxCanvasRef = useRef(null);
  const webcamRef = useRef(null);

  const [zIndexVideo, setZIndexVideo] = useState(5);
  const [zIndexVideo_Rep, setZIndexVideo_Rep] = useState(1);

  const [timerId, setTimerId] = useState(null);

  useEffect(() => {
    setFaceStatus(pStatus.init)
  }, []);

  /* Blazeface runs only in the webcam mode (not during the repetition) */
  /* Also, it starts running after hitting the 'record' button */
  useEffect(() => {
    console.log('faceStatus: ', faceStatus)
    switch (faceStatus) {
      case pStatus.runTf:
        if (webcamRef.current !== null) {
          /* run face engine and show galibo */
          runBlazeFace(webcamRef.current.video, canvasRef.current, setFaceStatus);
          drawRef(webcamRef.current.video, auxCanvasRef.current);
          setFaceStatus(pStatus.faceDetected);
        }
        break;
      case pStatus.init:
        setZIndexVideo_Rep(1)
      case pStatus.countdown:
        stopBlazeFace();
        if (auxCanvasRef.current !== null) {
          clearRef(auxCanvasRef.current);
        }
        break;
      case pStatus.record:
        startRecording();
        break;
      case pStatus.rep:
        setZIndexVideo_Rep(9)
        stopRecording();
        break;
      default:
        break;
    }
    // eslint-disable-next-line
  }, [faceStatus]);

  /* Detect when the video is ready */
  useEffect(() => {
    if (mediaBlobUrl !== null) {
      setVideo(mediaBlobUrl);

      console.log('AQUUUUUUUUIIIIIIII: ', mediaBlobUrl)

      if (handleSendButton !== undefined && mediaBlobUrl !== undefined){

        console.log('AQUUUUUUUUIIIIIIII222222: ', mediaBlobUrl)
        handleSendButton();
      }
    }
  }, [mediaBlobUrl, setVideo]);

  

  /* Unmounted component */
  useEffect(() => {
    loadBlazeFaceModel();
    return () => {
      stopBlazeFace();
    };
  }, []);
    
  /* Adapt to Camera Aspect Ratio */
   useEffect(() => {
    /* This extra step is needed in case a camera doesn't return the desired aspect ratio based on videoConstraints, which happens often... */
    handleGetAspect();
  }, [deviceId, devicePortrait]);

  function handleGetAspect() {
    if (webcamRef.current !== null) {
      const newAspect = webcamRef.current.video.offsetWidth / webcamRef.current.video.offsetHeight;
      // setVideoFeedAspectRatio(newAspect);
      if (newAspect>1){
        setVideoFeedAspectRatio(newAspect);
      }else{
        setVideoFeedAspectRatio(1);
      }

      if (devicePortrait) {
        setForceAspect(newAspect > 1); //Portrait To Landscape
      } else {
        setForceAspect(newAspect < 1); //Landscape To Portrait
      }
      
      console.log(`
      DeviceId: ${deviceId} 
      DevicePortrait: ${devicePortrait} 
      newAspect: ${newAspect}
      videoFeedAspectRatio: ${videoFeedAspectRatio} 
      VideoWidth: ${webcamRef.current.video.offsetWidth} 
      VideoHeight: ${webcamRef.current.video.offsetHeight} 
      `);
      console.log(webcamRef.current)
    }
  }  
    
  function handleOnUserMedia() {
    if (timerId) {
      clearTimeout(timerId); // Clear the previous timer if it exists
    }

    const newTimerId = setTimeout(() => {
      handleGetAspect();
    }, 200);

    setTimerId(newTimerId); // Set the new timer ID
  }

  useEffect(() => {
    return () =>{
        if (timerId) {
          clearTimeout(timerId); // Clear the timer when the component unmounts
        }
    }
  }, []);

  /* STATES :
   * before recording: webcam and canvas
   * recording: only webcam
   * repetition: video in loop
   */
  return (
    <>
      <Card data-tour='tourCam_7' className={`sig_Home_Camera_Root ${props.deviceLarge ? "" : "sig_Home_Camera_Root_LargeDevice"}`}>
        <CardActionArea>

          {permissions && 
              <Webcam 
              className={`sig_Home_Camera_Canvas sig_Home_Camera_Feed ${videoFeedAspectRatio < 1 ? 'sig_Home_Camera_Portrait' : `${videoFeedAspectRatio === 1 ? 'sig_Home_Camera_Square' : 'sig_Home_Camera_Landscape'}`}${forceAspect ? 'Forced' : ''}`} 
              ref={webcamRef} 
              audio={pWebcam.audio} 
              mirrored={pWebcam.mirrored} 
              screenshotFormat="image/jpeg" 
              videoConstraints={devicePortrait ? { ...pVideoConstraintsPortrait, deviceId: {exact: deviceId} } 
                                : { ...pVideoConstraints, deviceId: {exact: deviceId} } } 
              style={{ zIndex: zIndexVideo, audio: false }} 
              onUserMedia={handleOnUserMedia}/>}

          {faceStatus !== pStatus.rep ? (
            <>
              <div className="sig_Home_Camera_Canvas_BorderTop"></div>
              <div className="sig_Home_Camera_Canvas_BorderBottom"></div>
              
            </>
          ) : ( 
            <video 
            className={`sig_Home_Camera_Canvas sig_Home_Camera_Feed ${videoFeedAspectRatio < 1 ? 'sig_Home_Camera_Portrait' : `${videoFeedAspectRatio === 1 ? 'sig_Home_Camera_Square' : 'sig_Home_Camera_Landscape'}`}${forceAspect ? 'Forced' : ''}`} 
            src={mediaBlobUrl} style={{ zIndex: zIndexVideo_Rep }} 
            autoPlay 
            loop />

          )}

          {children}
        </CardActionArea>
        <CountdownTimer/>
        <RecordingChip status={status}/>


        { switchGalibo ? 
          <>
            <Tooltip title= {t("sRecordComponent.framing_advice")} placement="top" arrow>
              <div className="sig_Home_FramingContainer">
                <img className={'sig_Home_Framing_Back'} src={imgIdeal_0} alt={t("sRecordComponent.framing_advice")}/> 
                <img className={'sig_Home_Framing_Front'} src={imgIdeal_1} alt={t("sRecordComponent.framing_advice")}/> 
              </div>
            </Tooltip>
          </> 
          : 
          <>
          </>
        }        
      </Card>
    </>
  );
}
